/**
 * Copyright (c) Qwoach LLC 2021. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 11.02.21
 *
 */
import {AnalyticsManager,
    AmplitudeAnalytics,
    MixpanelAnalytics,
    GA4Analytics} from '@qwoach/analytics'

import {isDevEnv} from "./utils";


export default class Analytics extends AnalyticsManager {

    constructor() {
        super([
            new AmplitudeAnalytics(process.env.VUE_APP_ANALYTICS_AMPLITUDE_API_KEY, {debug: isDevEnv}),
            new MixpanelAnalytics(process.env.VUE_APP_ANALYTICS_MIXPANEL_API_KEY, {debug: isDevEnv}),
            new GA4Analytics(process.env.VUE_APP_ANALYTICS_GA4_API_KEY, process.env.VUE_APP_ANALYTICS_GA4_SECRET, {debug: isDevEnv}),
            new GA4Analytics(process.env.VUE_APP_ANALYTICS_GOOGLE_UA_API_KEY, "no-key", {debug: isDevEnv})
        ])
    }

    async trackUrlParams(){
        let url = new URL(window.location.href)
        let canSet = false
        let props = {}

        url.searchParams.forEach((value, key) => {
            props[key] = value
            canSet = true
        })

        if(canSet){
            await this.setUserPropsOnce(props)
        }

    }


    async trackPageView(props) {
        return super.trackPageView(props)
    }

    setUserId(userId) {
        super.setUserId(userId)
    }

    async setUserPropsOnce(props){
        return super.setUserPropsOnce(props)
    }

    async setUserProps(props) {
        return super.setUserProps(props)
    }

    async trackEvent(eventName, props) {
        return super.trackEvent(eventName, props)
    }

    async trackHoverEvent(element, eventName, props, triggerDelay) {
        return super.trackHoverEvent(element, eventName, props, triggerDelay)
    }

}
